import { render, staticRenderFns } from "./DGChun.vue?vue&type=template&id=d80cfc32&scoped=true&"
import script from "./DGChun.vue?vue&type=script&lang=js&"
export * from "./DGChun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80cfc32",
  null
  
)

export default component.exports